import React from "react";
import {Button, Form, Input} from "antd";
import {useTranslation} from "react-i18next";

type Value = {
  username: string;
  password: string;
};

type Props = {
  onSignin: (username: string, password: string) => void;
};
const LoginForm = ({onSignin}: Props) => {
  const {t} = useTranslation(["login"]);
  
  const handleSignin = (values: Value) => {
    if (onSignin) {
      onSignin(values.username, values.password);
    }
  };
  return (<Form
    name="basic"
    className={"form"}
    initialValues={{remember: true}}
    data-cy="loginForm"
    onFinish={handleSignin}
  >
    <div className={"title"}>{t("login.title")}</div>
    <Form.Item name="username" className={"item"}>
      <Input
        defaultValue={""}
        autoComplete={"off"}
        size={"large"}
        placeholder={t("login.input.phone")}
        data-cy="username"
      />
    </Form.Item>
    <Form.Item
      name="password"
      rules={[
        {
          required: true, message: "",
        },
      ]}
    >
      <Input.Password
        allowClear
        size={"large"}
        data-cy="password"
        placeholder={t("login.input.code")}
      />
    </Form.Item>
    <Form.Item className={"mt-8"}>
      <Button
        type={"primary"}
        size={"large"}
        color={"cyan"}
        className={"button"}
        htmlType="submit"
        data-cy="login"
      >
        {t("login.btn.phone")}
      </Button>
    </Form.Item>
  </Form>);
};

export default LoginForm;
